var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PostCreation_Modal_Image',{ref:"modal-image",attrs:{"mode":_vm.postModalMode}}),_c('PostCreation_Modal_Text',{ref:"modal-text",attrs:{"mode":_vm.postModalMode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }